import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SideMenuService } from "./modules/menus/services/sideMenu.service";
import { Subscription } from "rxjs";
import { UserService } from "./modules/user/services/user.service";
import { AuthModel } from "@nousmedis/nm-guard-auth";
import { fadeAnimation } from "./base-animations";
import { ConfirmationService, MessageService, PrimeNGConfig } from "primeng/api";
import { User } from "@nousmedis/guard-types/frontend";
import { environment } from "environment";
import { LayoutService, AppConfig } from './layout/service/app.layout.service';
import { LangService } from "./modules/user/services/lang.service";
import { FascicleSocketService } from "./modules/catalog-cloud/services/fascicle-socket.service";
import { Router, NavigationEnd } from "@angular/router";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [fadeAnimation]
})
export class AppComponent implements OnInit, OnDestroy {
  debugMode: boolean = false;
  debugWindow: boolean = false;
  debugAppId: string = "1da3571c5f40b0df142bac1544c1d6421eca505ffa51fa731d84e4f8104dd8f3";
  debugOrgId: string = "665982479c13ededb8acbb5d";
  debugUrl: string = "http://localhost:4850";

  backendServer: string = sessionStorage.getItem("api_server") || "^^no-api-server^^";
  isAuthRoute: boolean = false;
  isLoginRoute: boolean = false;

  title = "syncwall-client";
  expandedSideMenu: boolean = true;
  sideNavExpansion$: Subscription;
  user$: Subscription;
  user: User | undefined;
  logOut: boolean = true;

  constructor (
    public translate: TranslateService,
    private sideMenuService: SideMenuService,
    private userService: UserService,
    private auth: AuthModel,
    private primengConfig: PrimeNGConfig,
    private layoutService: LayoutService,
    private langSerivce: LangService,
    private socketService: FascicleSocketService,
    private router: Router
  ) {
    this.debugMode = environment.debug;
    this.user = this.auth.getCurrentUser();
    if (!this.user || this.user.id == "") this.logOut = true;

    this.userService.user$.subscribe((user) => {
      this.user = user;
    });

    if (this.user && this.user.id) {
      this.socketService.startSocket(this.user.id);
    }

    this.isAuthRoute = window.location.pathname.startsWith('/auth');
    this.isLoginRoute = window.location.pathname.startsWith('/login');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isAuthRoute = event.urlAfterRedirects.startsWith('/auth');
        this.isLoginRoute = event.urlAfterRedirects.startsWith('/login');
      }
    });

    this.urlDebug();
  }

  ngOnDestroy(): void {
    this.user$.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.user) {
      this.logOut = true;
    } else {
      this.logOut = false;
    }
    this.sideCollapsed();
    this.observerUser();
    this.langSerivce.initLangSite(this.user);
    this.primengConfig.ripple = true;
    const config: AppConfig = {
      ripple: true,
      inputStyle: 'outlined',
      menuMode: 'reveal',
      colorScheme: 'light',
      theme: 'cyan',
      menuTheme: "colorScheme",
      scale: 14
    };
    this.layoutService.config.set(config);
  }

  async urlDebug() {
    if (environment.debugauth) {
      sessionStorage.setItem('api_server', 'http://localhost:2300');
      sessionStorage.setItem('auth_server', 'http://localhost:3900/');
      sessionStorage.setItem('base_socket', 'http://localhost:2300/api/v1');
    }
  }

  sideCollapsed() {
    this.sideMenuService.toggle();
  }

  observerUser() {
    this.user$ = this.userService.user$.subscribe((user) => {
      this.user = user;
      this.logOut = !user || user.id == "";
    });
  }

  toogleDebugWindow() {
    this.debugWindow = !this.debugWindow;
  }
}
